import { render, staticRenderFns } from "./PopupTips.vue?vue&type=template&id=74f84b62"
import script from "./PopupTips.vue?vue&type=script&lang=js"
export * from "./PopupTips.vue?vue&type=script&lang=js"
import style0 from "./PopupTips.vue?vue&type=style&index=0&id=74f84b62&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports